const CategoryDescription = (val) => {
  if (val === 'お知らせ') {
    return 'E・ZO FUKUOKAからのお知らせニュースです。';
  }
  if (val === 'イベント情報') {
    return 'E・ZO FUKUOKAのイベントニュースです。';
  }
  if (val === 'HKT48劇場') {
    return 'HKT48 劇場に関するニュースです。';
  }
  if (val === 'MLB café FUKUOKA') {
    return 'MLB café FUKUOKAに関するニュースです。';
  }
  if (val === 'The FOODHALL') {
    return 'E・ZO FUKUOKAのThe FOODHALL内の各店舗に関するニュースです。';
  }
  if (val === 'teamLabForest') {
    return 'teamLabForestに関するニュースです。';
  }
  if (val === 'V-World AREA') {
    return 'V-World AREAに関するニュースです。';
  }
  if (val === 'イベントホール') {
    return 'E・ZO FUKUOKAのイベントホールに関するニュースです。';
  }
  if (val === 'よしもと福岡劇場') {
    return 'よしもと福岡 大和証券劇場に関するニュースです。';
  }
  if (val === '王貞治ベースボールミュージアム') {
    return '王貞治ベースボールミュージアムに関するニュースです。';
  }
  if (val === '絶景３兄弟') {
    return '絶景３兄弟 SMBC日興証券（すべZO SMBC日興証券・つりZO SMBC日興証券・のぼZO SMBC日興証券）に関するニュースです。';
  }
  if (val === 'うんこミュージアム') {
    return 'うんこミュージアムに関するニュースです。';
  }
  return false;
};

export default CategoryDescription;
